import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { AuthApiService } from 'src/app/services/auth-api.service';
import { getEmailRegExpression } from 'src/app/utils/utils.common';

@Component({
  selector: 'app-password-reset',
  templateUrl: './password-reset.component.html',
  styleUrls: ['./password-reset.component.scss']
})
export class PasswordResetComponent implements OnInit {

  busy: boolean = false;
  errorMsg: string;
  showError: boolean = false;
  showSuccess: boolean = false;
  emailRegExpression = getEmailRegExpression();

  email: string;

  constructor(
    private authApi: AuthApiService,
    private recaptchaV3Service: ReCaptchaV3Service,
    private router: Router
  ) { }

  ngOnInit(): void {
  }

  public ResetPassword() {
    this.busy = true;
    this.showError = false;
    this.showSuccess = false;
    this.errorMsg = '';

    this.recaptchaV3Service.execute('RequestPasswordReset').subscribe(() => {
      this.authApi.forgotPassword(this.email).subscribe({
        next: () => {
          this.busy = false;
          this.showSuccess = true;
          setTimeout(() => {
            this.router.navigate(['resetpassword', 'confirm'], {
              queryParams: { email: this.email },
            });
          }, 4000)
        },
        error: (error) => {
          this.showError = true;
          this.errorMsg = this.interpretError(error);
          this.busy = false;
        },
      });
    });
  }

  private interpretError(error: any): string {
    if (typeof error?.error?.ErrorDetail === 'string' && error.error.ErrorDetail.length > 0) {
      return error.error.ErrorDetail;
    }
    if (typeof error?.error?.errorDetail === 'string' && error.error.errorDetail.length > 0) {
      return error.error.errorDetail;
    }
    if (typeof error?.error?.message === 'string' && error.error.message.length > 0) {
      return error.error.message;
    }
    return 'Unable to request password reset. Please try again or contact support@dooya.co.za';
  }
}
